/**
 * AxeptioTokenName is the name of the query parameter that contains the Axeptio token.
 * This token is used to check if the user has accepted the cookies from Axeptio.
 *
 * @type {string}
 *
 */
export const AxeptioTokenName = 'axeptio_token';
